// // // Open Street
// import React, { useCallback } from 'react';
// import { fromLonLat } from 'ol/proj';
// import { Point } from 'ol/geom';
// import './ol.css';

// import { RMap, ROSM, RLayerVector, RFeature, ROverlay, RStyle, RControl } from 'rlayers';
// import locationIcon from './location.svg';

// function OrderMapPrint({ label, latitude, longitude }) {
//     const [collapsed, setCollapsed] = React.useState(false);

//     const newCenterLongitude = parseFloat(longitude) + 0.0025; // Ajusta este valor según tu necesidad

//     return (
//         <RMap
//             className='example-map mb-1'
//             initial={{ center: fromLonLat([longitude, latitude]), zoom: 15 }}
//         >
//             <ROSM />
//             <RLayerVector zIndex={10}>
//                 <RStyle.RStyle>
//                     <RStyle.RIcon src={locationIcon} anchor={[0.5, 0.8]} />
//                 </RStyle.RStyle>

//                 <RFeature
//                     geometry={new Point(fromLonLat([longitude, latitude]))}
//                     onClick={(e) =>
//                         e.map.getView().fit(e.target.getGeometry().getExtent(), {
//                             duration: 250,
//                             maxZoom: 10
//                         })
//                     }
//                 >
//                     {label && (
//                         <ROverlay className='example-overlay'>
//                             {label}
//                         </ROverlay>
//                     )}
//                 </RFeature>
//             </RLayerVector>
//         </RMap>
//     );
// }

// export default OrderMapPrint;

//Google maps
// import React from 'react';
// import { GoogleMap, Marker, useLoadScript } from '@react-google-maps/api';
// import locationIcon from './location.svg';
// import './ol.css';

// const containerStyle = {
//   width: '100%',
//   height: '300px',
// };

// function OrderMapPrint({ label, latitude, longitude }) {
//   const { isLoaded, loadError } = useLoadScript({
//     googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
//   });

//   if (loadError) return <div>Error cargando Google Maps</div>;
//   if (!isLoaded) return <div>Cargando mapa...</div>;

//   const center = {
//     lat: parseFloat(latitude),
//     lng: parseFloat(longitude),
//   };

//   return (
//     <GoogleMap
//       mapContainerStyle={containerStyle}
//       center={center}
//       zoom={17}
//     >
//       <Marker
//         position={center}
//         icon={{
//           url: locationIcon,
//           scaledSize: new window.google.maps.Size(40, 40),
//         }}
//         label={label ? { text: label, color: 'black', fontSize: '14px' } : undefined}
//       />
//     </GoogleMap>
//   );
// }

// export default OrderMapPrint;

import React from "react";

function OrderMapPrint({ label, latitude, longitude }) {
  const apiKey = "AIzaSyBK3x7I2zECXwzjFXM-WHI_c_sKDVTwslA";

  const mapUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${latitude},${longitude}&zoom=17&size=600x300&markers=${latitude},${longitude}&key=${apiKey}`;

  return (
    <img
      src={mapUrl}
      alt={`Mapa de ubicación${label ? `: ${label}` : ""}`}
      style={{ width: "100%", height: "230px", borderRadius: "4px" }}
    />
  );
}

export default OrderMapPrint;
